import { mainAxios } from "../../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "../mainService";


export const getCampañasClientes = async () => {
  try {
    const response = await mainAxios.get(
      `/v1/campania-cliente/list`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};